var _pattern, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStorageBanner = function SvgStorageBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 81,
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 736 81"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "storage-banner_svg__b",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6366f1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#8b5cf6",
      stopOpacity: 1
    }
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "storage-banner_svg__c",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1,
    fill: "#fff",
    opacity: 0.2
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "storage-banner_svg__a",
    width: 736,
    height: 81,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M724 0H12C5.373 0 0 5.373 0 12v57c0 6.627 5.373 12 12 12h712c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#storage-banner_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#storage-banner_svg__b)",
    d: "M0 0h736v81H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#storage-banner_svg__c)",
    d: "M0 0h736v81H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 40,
    r: 60,
    fill: "url(#storage-banner_svg__b)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 40,
    r: 40,
    fill: "url(#storage-banner_svg__b)",
    opacity: 0.6
  }))));
};
export default SvgStorageBanner;